module.exports = __webpack_public_path__ + "static/media/sync-alt.77f0aaa8.svg";